import React from "react";
import {
    Avatar,
    Button,
    Checkbox,
    Dropdown,
    Flex,
    Input,
    Text,
} from "@fluentui/react-northstar";
import styled from "styled-components";
import CardUser from "../../Cards/CardPositionEntreprise/CardUser";
import { AVATAR_DEFAULT } from "../../../../../constants";
import { useQuery } from "react-query";
import { _getAllHumainRessource } from "../../../api";

const DialogUpdateSupervisorHumainRessource = ({
    rh,
    teamHr,
    onSelectionChange,
    setNewRH,
}) => {
    //* QUERY
    //* QUERY
    //* QUERY
    const {
        data: allHumainRessource,
        isLoading: isLoadingAllHumainRessources,
        isFetching: isFetchingAllHumainRessources,
    } = useQuery(["getAllHumainRessource"], () => _getAllHumainRessource());

    // console.log("allManagers", allManagers);

    //* FUNCTIONS
    //* FUNCTIONS
    //* FUNCTIONS

    const initialState = teamHr?.reduce((acc, user) => {
        acc[user.id] = false;
        return acc;
    }, {});

    const [selectedUsers, dispatch] = React.useReducer(
        (state, action) => ({ ...state, ...action }),
        initialState
    );

    // React.useEffect(() => {
    //     const selected = teamManager.filter((user) => selectedUsers[user.id]);
    //     onSelectionChange(selected);
    // }, [selectedUsers, onSelectionChange]);

    //* sinon envoyer uniquement les id des user checked
    React.useEffect(() => {
        const selectedIds = Object.entries(selectedUsers)
            .filter(([_, isChecked]) => isChecked)
            .map(([id]) => parseInt(id));

        onSelectionChange(selectedIds);
    }, [selectedUsers, onSelectionChange]);
    //* sinon envoyer uniquement les id des user checked

    const values = Object.values(selectedUsers);
    const allSelected = values.every(Boolean);
    const someSelected = values.some(Boolean);
    const isMixed = allSelected ? true : someSelected ? "mixed" : false;

    // toggle alll checkBoxes
    const handleToggleAll = (_, { checked }) => {
        const updated = {};
        for (const id in selectedUsers) {
            updated[id] = checked;
        }
        dispatch(updated);
    };

    const handleToggleOne =
        (id) =>
        (_, { checked }) => {
            dispatch({ [id]: checked });
        };

    const selectedIds = Object.entries(selectedUsers)
        .filter(([_, isChecked]) => isChecked)
        .map(([id]) => parseInt(id));

    const selectedUserList = teamHr.filter((user) =>
        selectedIds.includes(user.id)
    );

    return (
        <Flex fill column>
            <Wrapper fill column gap="gap.medium">
                <Header fill column>
                    <InputLabel content="RH d'origine" fluid />
                    <div>
                        <CardUser
                            avatar={rh?.avatar}
                            full_name={`${rh?.display_name}`}
                            job_title={rh?.job_title}
                            hideTitle={true}
                            // onClick={() =>
                            //     _navigateToEmployee(employee?.id)
                            // }
                        />
                    </div>
                </Header>
                <Flex column fill>
                    <InputLabel content="RH destinataire" fluid />
                    <Dropdown
                        loading={
                            isLoadingAllHumainRessources ||
                            isFetchingAllHumainRessources
                        }
                        loadingMessage="Chargement des données ..."
                        noResultsMessage="Aucun résultat trouvé"
                        search
                        items={
                            allHumainRessource?.map((employee) => {
                                return {
                                    id: employee?.id,
                                    key: employee?.id,
                                    header: `${employee?.first_name} ${employee?.last_name}`,
                                    content: employee?.job_title,
                                    image: employee?.avatar.length
                                        ? employee?.avatar
                                        : AVATAR_DEFAULT,
                                };
                            }) ?? []
                        }
                        placeholder="Sélectionnez un nouveau RH"
                        checkable
                        fluid
                        getA11ySelectionMessage={{
                            onAdd: (item) => `${item} has been selected.`,
                        }}
                        onChange={(_, newRh) => {
                            setNewRH(newRh.value);
                        }}
                    />
                </Flex>
                <Flex
                    column
                    gap="gap.medium"
                    styles={{ paddingBottom: "30px" }}
                >
                    <InputLabel content="Personnes qui changeront de ressources humaines" />
                    <Flex
                        styles={{
                            height: "200px",
                            overflowY: "scroll",
                        }}
                        column
                        gap="gap.small"
                    >
                        <Checkbox
                            label="Toutes"
                            checked={isMixed}
                            onChange={handleToggleAll}
                        />
                        {teamHr?.map((user) => (
                            <Checkbox
                                key={user.id}
                                label={`${user.first_name} ${user.last_name}`}
                                checked={selectedUsers[user.id]}
                                onChange={handleToggleOne(user.id)}
                            />
                        ))}
                    </Flex>
                </Flex>
            </Wrapper>
        </Flex>
    );
};

export default DialogUpdateSupervisorHumainRessource;

const InputLabel = styled(Text)`
    color: #616161;
    font-family: "Segoe UI";
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 16px;
`;

const Header = styled(Flex)`
    padding-top: 35px;
`;

const Wrapper = styled(Flex)`
    /* height: 300px; */
    overflow-y: scroll;
    overflow-x: hidden;
    border-bottom: 1px solid #d1d1d1;
`;
